import { useQuery } from '@tanstack/react-query'
import { createVariationPreviewLink, previewTokenFromUrl } from '@/api/variations'
import { fetchPostPreview, type PostPreview } from '@/api/previews'

/** The exact platform mockups of a variation group, read through its preview link. */
export function useGroupPreview(groupId: string | null | undefined) {
  return useQuery<PostPreview>({
    queryKey: ['variation-preview', groupId],
    enabled: !!groupId,
    staleTime: 5 * 60_000,
    retry: false,
    queryFn: async () => {
      const link = await createVariationPreviewLink(groupId as string)
      const preview = await fetchPostPreview(previewTokenFromUrl(link.url))
      if (preview.kind !== 'options') throw new Error('A group link shows its options.')
      return preview
    },
  })
}
